export default __webpack_public_path__ + "static/5-4856a5bfd6fea077514add06b9d919d7.jpg";